module.exports = __webpack_public_path__ + "static/media/PIV_Icon.5490828b.jpg";